import React, { useState, useEffect } from 'react';
import { Phone, X, MessageCircle } from 'lucide-react';

const STICKY_DISMISSED_KEY = 'stickyCTADismissed';

const StickyContactBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(STICKY_DISMISSED_KEY);
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem(STICKY_DISMISSED_KEY, 'true');
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-cyan-700 to-cyan-800 text-white shadow-[0_-4px_20px_rgba(0,0,0,0.15)] transform transition-transform duration-500"
      data-testid="sticky-contact-bar"
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <MessageCircle size={20} className="text-cyan-200 shrink-0 hidden sm:block" />
          <p className="text-sm font-medium truncate">
            <span className="hidden md:inline">Struggling with sleep apnea or snoring? </span>
            <span className="font-bold">Free consultation with Dr. Yang</span>
            <span className="hidden lg:inline"> — custom oral appliances, nightguards & dental sleep medicine in Roseville, CA</span>
          </p>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <a
            href="tel:9167731122"
            className="inline-flex items-center gap-2 bg-white text-cyan-700 font-bold text-sm px-4 py-2 rounded-lg hover:bg-cyan-50 transition-colors"
            data-testid="sticky-call-button"
          >
            <Phone size={15} />
            <span className="hidden sm:inline">(916) 773-1122</span>
            <span className="sm:hidden">Call Now</span>
          </a>
          <button
            onClick={handleDismiss}
            className="text-cyan-200 hover:text-white transition-colors p-1"
            data-testid="sticky-dismiss-button"
            aria-label="Dismiss"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyContactBar;
